// New JavaScript for Automatic Sliding and Dot Navigation
document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.swiper', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  swiper.on('slideChange', function () {
    // This is necessary to accurately retrieve the desired data. 
    // Since the code without setTimeout selects old data
    setTimeout(() => {
      const colorElement = 'color-scheme';
      const navigationElement = document.querySelector(".swiper-navigation");
      const nextSlideElement = document.querySelector(".swiper-slide-active");

      if (!navigationElement || !nextSlideElement) {
        console.warn("Swiper navigation or next slide element not found.");
        return;
      }

      // Remove existing color scheme class from navigation
      const swiperPaginationDivClassList = navigationElement.className;
      const resultPaginationDiv = swiperPaginationDivClassList.split(" ");
      const finalPaginationClassValue = resultPaginationDiv.find(str => str.includes(colorElement));

      if (finalPaginationClassValue) {
        navigationElement.classList.remove(finalPaginationClassValue);
      }

      // Add color scheme class from next slide to navigation
      const swiperDivClassList = nextSlideElement.className;
      const result = swiperDivClassList.split(" ");
      const finalValue = result.find(str => str.includes(colorElement));

      if (finalValue) {
        navigationElement.classList.add(finalValue);
      }
    }, 0);

  });
  const swiperContainer = document.querySelector(".swiper");

  document.addEventListener("keydown", function (e) {
    if (e.key === "Tab" && e.shiftKey) {
      if (document.activeElement.closest(".swiper")) {
        e.preventDefault();

        const announcementLink = document.querySelector(".anouncement_slider a");
        const headerButton = document.querySelector("header .open-miniCart-btn");

        if (announcementLink) {
          announcementLink.focus();
        } else if (headerButton) {
          headerButton.focus();
        }
      }
    }
  });
});